import { MapPin, Phone } from 'lucide-react';

interface PrintablePosterContact {
  address: string | null;
  city: string | null;
  state: string | null;
  phone: string | null;
}

interface PrintablePosterFooterProps {
  company: PrintablePosterContact;
}

export default function PrintablePosterFooter({ company }: PrintablePosterFooterProps) {
  const location = [company.address, [company.city, company.state].filter(Boolean).join(' - ')].filter(Boolean).join(', ');

  return (
    <footer className="flex flex-wrap items-center justify-between gap-4 border-t border-slate-200 pt-4 text-sm text-slate-600">
      <div className="flex flex-wrap gap-x-7 gap-y-2">
        {location && (
          <span className="inline-flex items-center gap-1.5">
            <MapPin className="h-4 w-4 text-amber-500" />
            {location}
          </span>
        )}
        {company.phone && (
          <span className="inline-flex items-center gap-1.5">
            <Phone className="h-4 w-4 text-amber-500" />
            {company.phone}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
        <img src="/blackbelts-mark@2x.png" alt="" className="h-9 w-9 rounded-full bg-slate-950 p-1" />
        blackbelts.app
      </div>
    </footer>
  );
}
